const PGAdapter = require('../../common/pg-adapter')

const LOCATION_RELATIONSHIP_TABLE_NAME = 'avocado.data_location_relationship'
const LOCATION_RELATIONSHIP_COLUMNS = [
  'id',
  'location_id',
  'relationship_type',
  'relationship',
  'created_at',
  'updated_at'
]

class LocationRelationshipPgAdapter extends PGAdapter {
  constructor ({pgConnection, logger, username}) {
    super(pgConnection,
      LOCATION_RELATIONSHIP_TABLE_NAME,
      username,
      LOCATION_RELATIONSHIP_COLUMNS,
      'id',
      {},
      logger
    )
  }
}

module.exports = LocationRelationshipPgAdapter
